import { AHIcon, AHSeparator, AHText, AHWidgetTitleWrapper, Box } from "arkh";

import React, { useCallback } from "react";
import { FlatList } from "react-native";

import { graphql, useFragment } from "react-relay";

import { WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise$key } from "./__generated__/WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise.graphql";
import { WidgetIntegrationFlourishPraiseLeaderboardItem$key } from "./__generated__/WidgetIntegrationFlourishPraiseLeaderboardItem.graphql";
import { useWidgetLayoutContentSize } from "../useWidgetLayoutContentSize";
import { Image } from "expo-image";

export const WidgetIntegrationFlourishPraise = (props: {
  widget: WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise$key;
  storecastId?: string;
  mode?: "FOCUS" | "IDLE";

  interactive?: undefined | false;
}) => {
  const widget = useFragment(
    graphql`
      fragment WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise on WidgetIntegrationFlourishPraise {
        id
        overviewSize
        flourishTeams {
          id
          ...WidgetIntegrationFlourishPraiseLeaderboardItem
        }
      }
    `,
    props.widget
  );

  type Item = (typeof widget.flourishTeams)[number];

  const renderItem = useCallback(
    ({ item }: { item: Item }) => (
      <WidgetIntegrationFlourishPraiseLeaderboardItem
        item={item}
        index={widget.flourishTeams.indexOf(item)}
      />
    ),
    [widget.flourishTeams]
  );

  return (
    <Box color="surface" style={{ flex: 1 }}>
      <AHWidgetTitleWrapper>
        <Image
          style={{ flex: 1 }}
          contentFit="scale-down"
          contentPosition="left center"
          source={require("./flourish_logo_darkpurple.webp")}
        />
        <AHText type="subtitle">Top Praise Senders - Last 7 days</AHText>
      </AHWidgetTitleWrapper>
      <FlatList
        automaticallyAdjustContentInsets={false}
        showsVerticalScrollIndicator={false}
        data={widget.flourishTeams}
        renderItem={renderItem}
        ItemSeparatorComponent={AHSeparator}
      />
    </Box>
  );
};

function WidgetIntegrationFlourishPraiseLeaderboardItem(props: {
  item: WidgetIntegrationFlourishPraiseLeaderboardItem$key;
  index: number;
}) {
  const item = useFragment(
    graphql`
      fragment WidgetIntegrationFlourishPraiseLeaderboardItem on WidgetIntegrationFlourishPraiseLeaderboardItem {
        id
        praise
        title
      }
    `,
    props.item
  );
  const layout = useWidgetLayoutContentSize();
  return (
    <Box
      key={item.id}
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        height: layout.unit / 5.5,
      }}
      spaceVertical="small"
      spaceHorizontal="medium"
    >
      <AHIcon type="integration-flourish-praise" color="semiNegative" />
      <AHText
        spaceLeft="medium"
        style={{ flex: 1 }}
        numberOfLines={1}
        type="subtitle"
      >
        {item.title}
      </AHText>
      <AHText type="subtitle" color="darkText">
        {item.praise}
      </AHText>
    </Box>
  );
}
